/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Link from '@mui/material/Link';

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

// Soft UI Dashboard PRO React base styles
import typography from 'assets/theme/base/typography';

function Footer() {
    const links = [
        { href: 'https://www.innoova.cl/', name: 'Innoova Corps' },
        { href: 'https://www.innoova.cl/presentation', name: 'Nosotros' },
        { href: 'https://www.innoova.cl/blog', name: 'Blog' },
        { href: 'https://www.innoova.cl/license', name: 'Licencia' },
    ];
    const { size } = typography;

    const renderLinks = () =>
        links.map(link => (
            <SoftBox key={link.name} component="li" px={2} lineHeight={1}>
                <Link href={link.href} target="_blank">
                    <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        color="text"
                    >
                        {link.name}
                    </SoftTypography>
                </Link>
            </SoftBox>
        ));
/*
    return (
        <SoftBox
            width="100%"
            display="flex"
            flexDirection={{ xs: 'column', lg: 'row' }}
            justifyContent="space-between"
            alignItems="center"
            px={1.5}
        >
            <SoftBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexWrap="wrap"
                color="text"
                fontSize={size.sm}
                px={1.5}
            >
                &copy; {new Date().getFullYear()}
                <Link href="https://www.innoova.cl/" target="_blank">
                    <SoftTypography variant="button" fontWeight="medium">
                        &nbsp;Innoova Corps SpA&nbsp;
                    </SoftTypography>
                </Link>
                Innovamos tu negocio
            </SoftBox>
            <SoftBox
                component="ul"
                sx={({ breakpoints }) => ({
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    listStyle: 'none',
                    mt: 3,
                    mb: 0,
                    p: 0,

                    [breakpoints.up('lg')]: {
                        mt: 0,
                    },
                })}
            >
                {renderLinks()}
            </SoftBox>
        </SoftBox>
    ); */
}

export default Footer;
